import { Container, Row, Col } from "react-bootstrap";
import logo from '../assets/img/KD-1.png';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" style={{ width: "200px" }} />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end" >
            <div className="social-icon" style={{ marginTop: 10 }}>
              <a href="https://www.linkedin.com/in/kartikey-dwivedi/" target="_blank"  rel="noreferrer"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://github.com/kartikeydwi1997" target="_blank"  rel="noreferrer"><img src={navIcon2} alt="Icon" /></a>
            </div>
            <p>Copyright {new Date().getFullYear()}. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
